// Program Role Definitions - Shared across components
export const ROLE_DEFINITIONS = {
  // Management roles
  'ProgramDirector': { 
    display: 'Program Director', 
    category: 'Management', 
    description: 'Complete program oversight and management',
    permissions: ['program.manage', 'members.manage', 'staff.assign', 'events.manage', 'equipment.manage', 'communications.manage', 'registration.manage', 'analytics.view']
  },
  'ProgramAdmin': { 
    display: 'Program Admin', 
    category: 'Management', 
    description: 'Administrative control and user management',
    permissions: ['program.manage', 'members.manage', 'staff.assign', 'events.manage', 'registration.manage', 'analytics.view']
  },
  'TeamManager': { 
    display: 'Team Manager', 
    category: 'Management', 
    description: 'Team coordination and roster management',
    permissions: ['members.manage', 'roster.manage', 'events.view']
  },
  
  // Coaching roles
  'HeadCoach': { 
    display: 'Head Coach', 
    category: 'Coaching', 
    description: 'Lead coaching responsibilities and team management',
    permissions: ['roster.manage', 'events.manage', 'members.view', 'equipment.view']
  },
  'AssistantCoach': { 
    display: 'Assistant Coach', 
    category: 'Coaching', 
    description: 'Supporting coaching role with roster access',
    permissions: ['roster.view', 'events.view', 'members.view']
  },
  
  // Administrative roles
  'Registrar': { 
    display: 'Registrar', 
    category: 'Administrative', 
    description: 'Registration and application processing',
    permissions: ['registration.manage', 'applications.manage', 'members.view']
  },
  'CommunicationsLead': { 
    display: 'Communications Lead', 
    category: 'Administrative', 
    description: 'Team communications and announcements',
    permissions: ['communications.manage', 'broadcast.send', 'members.view']
  },
  'EquipmentFacilitiesLead': { 
    display: 'Equipment Manager', 
    category: 'Administrative', 
    description: 'Equipment and facilities management',
    permissions: ['equipment.manage', 'facilities.manage', 'members.view']
  },
  
  // Participant roles
  'Player': { 
    display: 'Player', 
    category: 'Participants', 
    description: 'Active program participant',
    permissions: ['program.view', 'events.view', 'roster.view']
  },
  'Observer': { 
    display: 'Observer', 
    category: 'Participants', 
    description: 'View-only access to program information',
    permissions: ['program.view']
  },
};

// All available roles
export const ALL_ROLES = Object.keys(ROLE_DEFINITIONS);

// Category definitions with colors and icons
export const ROLE_CATEGORIES = {
  Management: { 
    label: 'Management', 
    color: '#dc2626', 
    icon: '👑',
    description: 'Leadership and oversight roles'
  },
  Coaching: { 
    label: 'Coaching', 
    color: '#2563eb', 
    icon: '🏃‍♂️',
    description: 'Coaching and training staff'
  },
  Administrative: { 
    label: 'Administrative', 
    color: '#059669', 
    icon: '📋',
    description: 'Support and administrative functions'
  },
  Participants: { 
    label: 'Participants', 
    color: '#6b7280', 
    icon: '👤',
    description: 'Program participants and observers'
  },
};

// Category display order
export const CATEGORY_ORDER = ['Management', 'Coaching', 'Administrative', 'Participants'];

// Helper functions
export const getRoleInfo = (role) => ROLE_DEFINITIONS[role] || { display: role, category: 'Unknown', description: 'Unknown role' };

export const getRolesByCategory = (category) => 
  ALL_ROLES.filter(role => ROLE_DEFINITIONS[role]?.category === category);

export const getCategoryColor = (category) => 
  ROLE_CATEGORIES[category]?.color || '#6b7280';

export const getRoleColor = (role) => {
  const roleInfo = ROLE_DEFINITIONS[role];
  return roleInfo ? getCategoryColor(roleInfo.category) : '#6b7280';
};

export const hasPermission = (role, permission) => {
  const roleInfo = ROLE_DEFINITIONS[role];
  return roleInfo?.permissions?.includes(permission) || false;
};

export const getManagementRoles = () => getRolesByCategory('Management');
export const getCoachingRoles = () => getRolesByCategory('Coaching');
export const getAdministrativeRoles = () => getRolesByCategory('Administrative');
export const getParticipantRoles = () => getRolesByCategory('Participants');






































